import { Container, Typography, Card, CardContent, Box } from "@mui/material";
import Footer from "../components/Footer";

const RefundPolicy = () => {
  const WEBSITE = "Phoenix Play Zone";
  
  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "#1f2937",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#1f2937",
          py: 4,
          // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
        }}
      >
        <Container maxWidth="md" sx={{ textAlign: "center" }}>
          <Typography
            variant="h4"
            gutterBottom
            sx={{ fontWeight: "bold", color: "white" }}
          >
            Refund Policy
          </Typography>
          <Typography variant="subtitle1" color="white">
            Explore our premium courts for futsal, badminton, and more.
          </Typography>
        </Container>
      </Box>
      <Box sx={{ flexGrow: 1, backgroundColor: "#1f2937" }}>
        <Container maxWidth="md" className="px-5">
          <Card className="shadow-lg rounded-2xl" sx={{ backgroundColor: "#1f2937", color: 'white' }}>
            <CardContent className="p-6">
              <Typography variant="body1" className="mb-4">
                Thank you for choosing <strong>{WEBSITE}</strong>.
                We strive to provide you with the best booking experience
                possible.
              </Typography>
              <br/>
              <Typography variant="h6" className="mt-6 font-semibold" sx={{ color: '#e5e7eb', textDecoration: 'underline'}}>
                No Refunds
              </Typography>
              <Typography variant="body1" className="mb-4">
                Once a booking is placed, it is considered final. We do not
                offer refunds for any cancellations, changes, or unused
                bookings.
              </Typography>
              <br/>
              <Typography variant="h6" className="mt-6 font-semibold" sx={{ color: '#e5e7eb', textDecoration: 'underline'}}>
                Changes to Bookings
              </Typography>
              <Typography variant="body1" className="mb-4">
                If you need to modify your booking, please contact our support
                team as soon as possible. While we cannot guarantee changes, we
                will do our best to accommodate your request based on
                availability.
              </Typography>
              <br/>
              <Typography variant="h6" className="mt-6 font-semibold" sx={{ color: '#e5e7eb', textDecoration: 'underline'}}>
                Non-Transferable Bookings
              </Typography>
              <Typography variant="body1" className="mb-4">
                Bookings are non-transferable and can only be used by the
                individual or group for whom they were originally made.
              </Typography>
              <br/>
              <Typography variant="h6" className="mt-6 font-semibold" sx={{ color: '#e5e7eb', textDecoration: 'underline'}}>
                Exceptional Circumstances
              </Typography>
              <Typography variant="body1" className="mb-4">
                In case of extreme circumstances (e.g., venue closure,
                government restrictions), we may offer rescheduling options at
                our discretion.
              </Typography>
              <br/>
              <Typography variant="h6" className="mt-6 font-semibold" sx={{ color: '#e5e7eb', textDecoration: 'underline'}}>
                Contact Us
              </Typography>
              <Typography variant="body1">
                If you have any questions or concerns regarding our no refund
                policy, please contact our customer support team. We are here to
                assist you.
              </Typography>
            </CardContent>
          </Card>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
};

export default RefundPolicy;
